import { __decorate, __metadata } from "tslib";
import { vec3 } from 'gl-matrix';
import { singleton, inject } from 'mana-syringe';
import { GeometryAABBUpdater } from './interfaces';
import { TextService } from '../text';
import { Shape } from '../../types';

var TextUpdater =
/** @class */
function () {
  function TextUpdater() {}

  TextUpdater.prototype.update = function (parsedStyle) {
    var _a = parsedStyle.text,
        text = _a === void 0 ? '' : _a,
        textAlign = parsedStyle.textAlign,
        lineWidth = parsedStyle.lineWidth,
        textBaseline = parsedStyle.textBaseline,
        _b = parsedStyle.x,
        x = _b === void 0 ? 0 : _b,
        _c = parsedStyle.y,
        y = _c === void 0 ? 0 : _c,
        dx = parsedStyle.dx,
        dy = parsedStyle.dy;
    var metrics = this.textService.measureText(text, parsedStyle);
    parsedStyle.metrics = metrics;
    var width = metrics.width,
        height = metrics.height,
        lineHeight = metrics.lineHeight,
        fontProperties = metrics.fontProperties; // anchor is left-top by default

    var halfExtents = vec3.fromValues(width / 2, height / 2, 0); // default 'left'

    var anchor = [0, 1];
    var lineXOffset = 0;

    if (textAlign === 'center') {
      lineXOffset = lineWidth.value / 2;
      anchor = [0.5, 1];
    } else if (textAlign === 'right' || textAlign === 'end') {
      lineXOffset = lineWidth.value;
      anchor = [1, 1];
    } // update anchor


    parsedStyle.anchor = anchor;
    var lineYOffset = 0;

    if (textBaseline === 'middle') {
      // eslint-disable-next-line prefer-destructuring
      lineYOffset = halfExtents[1];
    } else if (textBaseline === 'top' || textBaseline === 'hanging') {
      lineYOffset = halfExtents[1] * 2;
    } else if (textBaseline === 'alphabetic') {
      lineYOffset = lineHeight - fontProperties.ascent;
    } else if (textBaseline === 'bottom' || textBaseline === 'ideographic') {
      lineYOffset = 0;
    } // TODO: ideographic & bottom


    if (dx && dx.unit === 'px') {
      lineXOffset += dx.value;
    }

    if (dy && dy.unit === 'px') {
      lineYOffset += dy.value;
    }

    return {
      width: halfExtents[0] * 2,
      height: halfExtents[1] * 2,
      x: x,
      y: y,
      offsetX: lineXOffset,
      offsetY: lineYOffset
    };
  };

  __decorate([inject(TextService), __metadata("design:type", TextService)], TextUpdater.prototype, "textService", void 0);

  TextUpdater = __decorate([singleton({
    token: {
      token: GeometryAABBUpdater,
      named: Shape.TEXT
    }
  })], TextUpdater);
  return TextUpdater;
}();

export { TextUpdater };